import { Component, OnInit } from '@angular/core';
import { FilterModel } from 'src/Models/filterModel';
import { CheckAuth } from 'src/Services/utility.service';
import { Title } from '@angular/platform-browser';
import { LifelineNLADClaimService } from 'src/Services/nladClaim.service';
import { InrollProductsCompanyModel } from 'src/Models/InrollProductsCompanyModel';
import { ClaimStateModel } from 'src/Models/ClaimStateModel';
import { EBBClaimProcessDetailsModel } from 'src/Models/EBBClaimProcessDetailsModel';
import { ToastrService } from 'ngx-toastr';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-admin-claim-details-lifeline-reports',
  templateUrl: './admin-claim-details-lifeline-reports.component.html',
  styleUrls: ['./admin-claim-details-lifeline-reports.component.css']
})
export class AdminClaimDetailsLifelineReportsComponent implements OnInit {
  filterModel = new FilterModel();
  listOfData: EBBClaimProcessDetailsModel[];
  listOfExportData: EBBClaimProcessDetailsModel[];
  tokenKey: string = '';
  _userID: any;

  currentPage: number = 1;
  totalRecordCount: number = -1;
  keywordFilter: string = '';
  OrderBy: string = '';
  isAscending: boolean = false

  upDowSubscriberIDCSS: string = '';
  upDowRateCSS: string = '';
  upDowReasonCodeCSS: string = '';
  upDowtribalLinkUpChargesWaivedCSS: string = '';
  upDowSPINCSS: string = '';
  upDowSACCSS: string = '';
  upDowLastNameCSS: string = '';
  upDowFirstNameCSS: string = '';
  upDowStreetAddressCSS: string = '';
  upDowCityCSS: string = '';
  upDowStateCSS: string = '';
  upDowZipCSS: string = '';
  upDowPhoneNumberCSS: string = '';
  upDowETCGeneralCSS: string = '';
  upDowServiceTypeCSS: string = '';
  upDowTribalBenefitFlagCSS: string = '';
  upDowCreatedDateCSS: string = '';
  upDowYearsCSS: string = '';
  upDowMonthsCSS: string = '';

  dropdownMonths = [];
  selectedItemsMonths = [];
  dropdownSettingMonths = {};
  listOfMonths = [];

  dropdownYears = [];
  selectedItemsYears = [];
  dropdownSettingYears = {};
  listOfYears = [];
  monthText = [];

  listOfInrollProductCompany: InrollProductsCompanyModel[];
  dropdownCompanies = [];
  selectedItemsCompanies = [];
  dropdownSettingCompanies = {};
  listOfCompany = [];

  listOfStateData: ClaimStateModel[];
  dropdownStates = [];
  selectedItemsStates = [];
  dropdownSettingStates = {};
  listOfStates = [];

  companyName: string = '';
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  isloading: boolean = false;
  stateName: string = '';
  isSummaryReport: boolean = false;
  isMonthlyCountReport: boolean = false;
  isYearlyCountReport: boolean = false;

  constructor(private readonly nladClaimService: LifelineNLADClaimService,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this._userID = sessionStorage.getItem('UserId');
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.titleService.setTitle('Lifeline Claim Details Report');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }
  ngOnInit() {
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
    this.filterModel.orderBy = 'Id';
    this.filterModel.userID = this._userID;
    this.filterModel.productId = 0;
    this.filterModel.months = '0';
    this.filterModel.years = '0';
    this.filterModel.state = '';
    if (sessionStorage.getItem('DetailReportsYear') != null)
      this.filterModel.years = sessionStorage.getItem('DetailReportsYear');
    if (sessionStorage.getItem('DetailReportsMonths') != null)
      this.filterModel.months = sessionStorage.getItem('DetailReportsMonths');
    if (sessionStorage.getItem('DetailReportsProviderId') != null)
      this.filterModel.providerId = sessionStorage.getItem('DetailReportsProviderId');
    if (sessionStorage.getItem('DetailReportsCompanyName') != null)
      this.companyName = sessionStorage.getItem('DetailReportsCompanyName');
    if (sessionStorage.getItem('DetailReportsState') != null)
      this.filterModel.stateName = sessionStorage.getItem('DetailReportsState');

    if (sessionStorage.getItem('ReportFlag') == 'Summary')
      this.isSummaryReport = true;
    else if (sessionStorage.getItem('ReportFlag') == 'Monthly')
      this.isMonthlyCountReport = true;
    else if (sessionStorage.getItem('ReportFlag') == 'Yearly')
      this.isYearlyCountReport = true;

    this.GetLifelineClaimProcessDetailsReports();
    this.GetClaimState();

    this.monthText.push({ 'id': 1, 'itemName': 'January' });
    this.monthText.push({ 'id': 2, 'itemName': 'February' });
    this.monthText.push({ 'id': 3, 'itemName': 'March' });
    this.monthText.push({ 'id': 4, 'itemName': 'April' });
    this.monthText.push({ 'id': 5, 'itemName': 'May' });
    this.monthText.push({ 'id': 6, 'itemName': 'June' });
    this.monthText.push({ 'id': 7, 'itemName': 'July' });
    this.monthText.push({ 'id': 8, 'itemName': 'August' });
    this.monthText.push({ 'id': 9, 'itemName': 'September' });
    this.monthText.push({ 'id': 10, 'itemName': 'October' });
    this.monthText.push({ 'id': 11, 'itemName': 'November' });
    this.monthText.push({ 'id': 12, 'itemName': 'December' });
  }

  GetLifelineClaimProcessDetailsReports() {
    this.blockDocument();
    this.listOfData = [];
    this.isloading = true;
    this.filterModel.IsExport = false;
    this.nladClaimService.GetLifelineClaimProcessDetailsReportsV2(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.isloading = false;
        this.unblockDocument();
        if (data != null) {
          this.listOfData = data['listOfData'];
          if (this.listOfData != null) {
            if (this.listOfData.length > 0) {
              this.totalRecordCount = this.listOfData[0].totalRecords;
            }
            else
              this.totalRecordCount = 0;
          }
          else
            this.totalRecordCount = 0;
        }
      },
      error => {
        this.isloading = false;
        this.unblockDocument();
        console.log(error);
      }
    );
  }

  pageChanged($event: any) {
    this.filterModel.pageNumber = $event.page;
    this.currentPage = $event.page;
    this.GetLifelineClaimProcessDetailsReports();
  }

  // sort(sortBy: any) {
  //   this.upDowSubscriberIDCSS = '';
  //   this.upDowRateCSS = '';
  //   this.upDowReasonCodeCSS = '';
  //   this.upDowtribalLinkUpChargesWaivedCSS = '';
  //   this.upDowSPINCSS = '';
  //   this.upDowSACCSS = '';
  //   this.upDowLastNameCSS = '';
  //   this.upDowFirstNameCSS = '';
  //   this.upDowStreetAddressCSS = '';
  //   this.upDowCityCSS = '';
  //   this.upDowStateCSS = '';
  //   this.upDowZipCSS = '';
  //   this.upDowPhoneNumberCSS = '';
  //   this.upDowETCGeneralCSS = '';
  //   this.upDowServiceTypeCSS = '';
  //   this.upDowTribalBenefitFlagCSS = '';
  //   this.upDowCreatedDateCSS = '';
  //   this.upDowYearsCSS = '';
  //   this.upDowMonthsCSS = '';

  //   this.isAscending = !this.isAscending;
  //   this.filterModel.orderBy = this.isAscending ? sortBy : sortBy + ' DESC';

  //   switch (sortBy) {
  //     case 'subscriberID': this.upDowSubscriberIDCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'rate': this.upDowRateCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'reasonCode': this.upDowReasonCodeCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'tribalLinkUpChargesWaived': this.upDowtribalLinkUpChargesWaivedCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'spin': this.upDowSPINCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'sac': this.upDowSACCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'lastName': this.upDowLastNameCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'firstName': this.upDowFirstNameCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'streetAddress': this.upDowStreetAddressCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'city': this.upDowCityCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'state': this.upDowStateCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'zip': this.upDowZipCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'phoneNumber': this.upDowPhoneNumberCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'etcGeneral': this.upDowETCGeneralCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'serviceType': this.upDowServiceTypeCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'tribalBenefitFlag': this.upDowTribalBenefitFlagCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'createdDate': this.upDowCreatedDateCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'years': this.upDowYearsCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     case 'months': this.upDowMonthsCSS = this.isAscending ? 'fa fa-arrow-down' : 'fa fa-arrow-up'; break;
  //     default: break;
  //   }
  //   this.OrderBy = sortBy;
  //   this.GetLifelineClaimProcessDetailsReports();
  // }

  sort(sortBy: any) {
    this.upDowSubscriberIDCSS = '';
    this.upDowRateCSS = '';
    this.upDowReasonCodeCSS = '';
    this.upDowtribalLinkUpChargesWaivedCSS = '';
    this.upDowSPINCSS = '';
    this.upDowSACCSS = '';
    this.upDowLastNameCSS = '';
    this.upDowFirstNameCSS = '';
    this.upDowStreetAddressCSS = '';
    this.upDowCityCSS = '';
    this.upDowStateCSS = '';
    this.upDowZipCSS = '';
    this.upDowPhoneNumberCSS = '';
    this.upDowETCGeneralCSS = '';
    this.upDowServiceTypeCSS = '';
    this.upDowTribalBenefitFlagCSS = '';
    this.upDowCreatedDateCSS = '';
    this.upDowYearsCSS = '';
    this.upDowMonthsCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filterModel.orderBy = sortBy + ' DESC';

      if (sortBy === 'subscriberID') this.upDowSubscriberIDCSS = 'fa fa-arrow-down';
      else if (sortBy === 'rate') this.upDowRateCSS = 'fa fa-arrow-down';
      else if (sortBy === 'reasonCode') this.upDowReasonCodeCSS = 'fa fa-arrow-down';
      else if (sortBy === 'tribalLinkUpChargesWaived') this.upDowtribalLinkUpChargesWaivedCSS = 'fa fa-arrow-down';
      else if (sortBy === 'spin') this.upDowSPINCSS = 'fa fa-arrow-down';
      else if (sortBy === 'sac') this.upDowSACCSS = 'fa fa-arrow-down';
      else if (sortBy === 'lastName') this.upDowLastNameCSS = 'fa fa-arrow-down';
      else if (sortBy === 'firstName') this.upDowFirstNameCSS = 'fa fa-arrow-down';
      else if (sortBy === 'streetAddress') this.upDowStreetAddressCSS = 'fa fa-arrow-down';
      else if (sortBy === 'city') this.upDowCityCSS = 'fa fa-arrow-down';
      else if (sortBy === 'state') this.upDowStateCSS = 'fa fa-arrow-down';
      else if (sortBy === 'zip') this.upDowZipCSS = 'fa fa-arrow-down';
      else if (sortBy === 'phoneNumber') this.upDowPhoneNumberCSS = 'fa fa-arrow-down';
      else if (sortBy === 'etcGeneral') this.upDowETCGeneralCSS = 'fa fa-arrow-down';
      else if (sortBy === 'serviceType') this.upDowServiceTypeCSS = 'fa fa-arrow-down';
      else if (sortBy === 'tribalBenefitFlag') this.upDowTribalBenefitFlagCSS = 'fa fa-arrow-down';
      else if (sortBy === 'createdDate') this.upDowCreatedDateCSS = 'fa fa-arrow-down';
      else if (sortBy === 'years') this.upDowYearsCSS = 'fa fa-arrow-down';
      else if (sortBy === 'months') this.upDowMonthsCSS = 'fa fa-arrow-down';

    } else {
      this.isAscending = false;
      this.filterModel.orderBy = sortBy;

      if (sortBy === 'subscriberID') this.upDowSubscriberIDCSS = 'fa fa-arrow-up';
      else if (sortBy === 'rate') this.upDowRateCSS = 'fa fa-arrow-up';
      else if (sortBy === 'reasonCode') this.upDowReasonCodeCSS = 'fa fa-arrow-up';
      else if (sortBy === 'tribalLinkUpChargesWaived') this.upDowtribalLinkUpChargesWaivedCSS = 'fa fa-arrow-up';
      else if (sortBy === 'spin') this.upDowSPINCSS = 'fa fa-arrow-up';
      else if (sortBy === 'sac') this.upDowSACCSS = 'fa fa-arrow-up';
      else if (sortBy === 'lastName') this.upDowLastNameCSS = 'fa fa-arrow-up';
      else if (sortBy === 'firstName') this.upDowFirstNameCSS = 'fa fa-arrow-up';
      else if (sortBy === 'streetAddress') this.upDowStreetAddressCSS = 'fa fa-arrow-up';
      else if (sortBy === 'city') this.upDowCityCSS = 'fa fa-arrow-up';
      else if (sortBy === 'state') this.upDowStateCSS = 'fa fa-arrow-up';
      else if (sortBy === 'zip') this.upDowZipCSS = 'fa fa-arrow-up';
      else if (sortBy === 'phoneNumber') this.upDowPhoneNumberCSS = 'fa fa-arrow-up';
      else if (sortBy === 'etcGeneral') this.upDowETCGeneralCSS = 'fa fa-arrow-up';
      else if (sortBy === 'serviceType') this.upDowServiceTypeCSS = 'fa fa-arrow-up';
      else if (sortBy === 'tribalBenefitFlag') this.upDowTribalBenefitFlagCSS = 'fa fa-arrow-up';
      else if (sortBy === 'createdDate') this.upDowCreatedDateCSS = 'fa fa-arrow-up';
      else if (sortBy === 'years') this.upDowYearsCSS = 'fa fa-arrow-up';
      else if (sortBy === 'months') this.upDowMonthsCSS = 'fa fa-arrow-up';
    }

    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.GetLifelineClaimProcessDetailsReports();
  }


  setMonthsText(id) {
    return this.monthText.filter(m => m.id == id)[0].itemName;
  }

  removeElemetninArrayById(array, element) {
    return array.filter(e => e.id !== element);
  }

  GetClaimState() {
    this.nladClaimService.GetClaimLifelineState(this.tokenKey).subscribe(
      data => {
        if (data != null) {
          this.listOfStateData = data['listOfData'];
          if (this.listOfStateData != null) {
            if (this.listOfStateData.length > 0) {

              for (let iCounter = 0; iCounter < this.listOfStateData.length; iCounter++) {
                this.dropdownStates.push({ 'id': this.listOfStateData[iCounter].shortName, 'itemName': this.listOfStateData[iCounter].name });
              }
            }
          }
          this.dropdownSettingStates = {
            singleSelection: true,
            text: 'Select State',
            enableSearchFilter: true,
            classes: 'borderLessTextBoxGreen',
            badgeShowLimit: 1,
            noDataLabel: 'No State',
            showCheckbox: false,
            enableFilterSelectAll: false
          };
          if (this.filterModel.stateName != "0") {
            let stateName = this.dropdownStates.filter(m => m.id == this.filterModel.stateName);
            this.selectedItemsStates = stateName;
          }

        }
      },
      error => {
        console.log(error);
      }
    );
  }

  onSelectedStates($event) {

    this.listOfStates = this.removeElemetninArrayById(this.listOfStates, $event.id)
    this.listOfStates.push($event.id);
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.state = $event.id;
    this.filterModel.stateName = $event.id;
    this.GetLifelineClaimProcessDetailsReports();
  }

  onDeSelectedStates($event) {
    if (this.listOfStates != null) {
      if (this.listOfStates.length > 0) {
        this.listOfStates = this.removeElemetninArrayById(this.listOfStates, $event.id)
      }
    }
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.state = $event.id;
    this.GetLifelineClaimProcessDetailsReports();
  }

  onSelectAllStates($event) {
    for (const item of $event) {
      if (this.listOfStates != null) {
        if (this.listOfStates.length > 0) {
          this.listOfStates = this.removeElemetninArrayById(this.listOfStates, item.id)
          this.listOfStates.push(item.id);
        }
        else {
          this.listOfStates.push(item.id);
        }
      }
    }
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.state = $event[0].id;
    this.GetLifelineClaimProcessDetailsReports();
  }

  onDeSelectAllStates($event) {
    this.listOfStates = [];
    this.currentPage = 1;
    this.filterModel.pageNumber = '1';
    this.filterModel.state = '';
    this.GetLifelineClaimProcessDetailsReports();
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  ExportLifelineClaimDetailsReport() {
    this.blockDocument();
    this.listOfExportData = [];
    this.isloading = true;
    this.filterModel.IsExport = true;
    this.nladClaimService.GetLifelineClaimProcessDetailsReportsV2(this.tokenKey, this.filterModel).subscribe(
      data => {
        if (data != null) {
          this.listOfExportData = data['listOfData'];
          if (this.listOfExportData != null) {
            if (this.listOfExportData.length > 0) {
              setTimeout(() => {
                this.DownloadLifelineClaimDetailsReport();
                this.isloading = false;
                this.unblockDocument();
              }, 2000);
            }
            else {
              this.unblockDocument();
              this.isloading = false;
              this.toastr.error("No record found", "Error");
            }
          }
          else {
            this.unblockDocument();
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
      },
      error => {
        this.isloading = false;
        this.unblockDocument();
        console.log(error);
      }
    );
  }

  DownloadLifelineClaimDetailsReport() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportInrollLifelineClaimDetailsReport';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportInrollLifelineClaimDetailsReport.xls");
  }
}
